import Home from './components/Home.vue'
import ThankYou from './components/ThankYou.vue'


export const routes = [
  { path: '/cannabis', component: Home },
  { path: '/thankyou', component: ThankYou }
];


// WEBPACK FOOTER //
// ./src/routes.js